import { IS_PROD } from 'modules/common/const';
import { OChainId } from './chainIDs';
import { BFF_BASE_URL_PROD, BFF_BASE_URL_STAGE } from './const';

/**
 * RPC URLS for HTTP providers by network id.
 */

const RPC_URL = `${IS_PROD ? BFF_BASE_URL_PROD : BFF_BASE_URL_STAGE}/multi-rpc/proxy`;

export const RPC_CONFIG = {
  [OChainId.ethereum]: `${RPC_URL}/eth`,
  [OChainId.holesky]: `${RPC_URL}/eth_holesky`,
  [OChainId.sepolia]: `${RPC_URL}/eth_sepolia`,
  [OChainId.binanceSmartChain]: `${RPC_URL}/bsc`,
  [OChainId.binanceSmartChainTestnet]: `${RPC_URL}/bsc_testnet_chapel`,
  [OChainId.base]: `${RPC_URL}/base`,
  [OChainId.baseSepoliaTestnet]: `${RPC_URL}/base_sepolia`,
  [OChainId.zircuit]: 'https://zircuit1.p2pify.com/',
  [OChainId.berachain]: 'https://rpc.berachain.com',
  [OChainId.berachainBartioTestnet]: 'https://bartio.rpc.b-harvest.io',
  [OChainId.corn]: 'https://rpc.ankr.com/corn_maizenet',
  [OChainId.swell]: 'https://rpc.ankr.com/swell',
  [OChainId.morph]: 'https://rpc-quicknode.morphl2.io',
  [OChainId.morphHolesky]: 'https://rpc-quicknode-holesky.morphl2.io/',
  [OChainId.sonic]: 'https://rpc.soniclabs.com',
} as const;
